"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadChangeLogVersionFile = exports.changeLogViewDetailsList = exports.analyticSessionSuccess = exports.analyticSessionReset = exports.analyticSessionFetchRecording = exports.analyticSessionError = exports.analyticSessionDelete = exports.analyticSessionAddSite = exports.analyticSessionAddReport = void 0;
var _analyticSession = require("./analyticSession.constant");
// @flow

// common success
var analyticSessionSuccess = function analyticSessionSuccess(actionType, data) {
  return {
    type: _analyticSession.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.analyticSessionSuccess = analyticSessionSuccess;
var analyticSessionError = function analyticSessionError(actionType, error) {
  return {
    type: _analyticSession.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * add site
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
exports.analyticSessionError = analyticSessionError;
var analyticSessionAddSite = function analyticSessionAddSite(data) {
  return {
    type: _analyticSession.actionTypes.ADD_SESSION_SITE,
    payload: data
  };
};

/**
 * add report
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
exports.analyticSessionAddSite = analyticSessionAddSite;
var analyticSessionAddReport = function analyticSessionAddReport(data) {
  return {
    type: _analyticSession.actionTypes.ADD_SESSION_REPORT,
    payload: data
  };
};

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to delete data.
 */
exports.analyticSessionAddReport = analyticSessionAddReport;
var analyticSessionDelete = function analyticSessionDelete(data) {
  return {
    type: _analyticSession.actionTypes.DELETE,
    payload: data
  };
};

/**
 * fetch recording
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.analyticSessionDelete = analyticSessionDelete;
var analyticSessionFetchRecording = function analyticSessionFetchRecording(data) {
  return {
    type: _analyticSession.actionTypes.FETCH_RECORDING,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.analyticSessionFetchRecording = analyticSessionFetchRecording;
var analyticSessionReset = function analyticSessionReset(data) {
  return {
    type: _analyticSession.actionTypes.RESET,
    payload: data
  };
};

/**
 * list changes performed
 * @param payload
 * @returns api response
 * @description this function used to get data of change log changes performed.
 */
exports.analyticSessionReset = analyticSessionReset;
var changeLogViewDetailsList = function changeLogViewDetailsList(data) {
  return {
    type: _analyticSession.actionTypes.CHANGE_LOG_VIEW_DETAILS,
    payload: data
  };
};

/**
 * download html version
 * @param payload
 * @returns api response
 * @description this function used to download sheet.
 */
exports.changeLogViewDetailsList = changeLogViewDetailsList;
var downloadChangeLogVersionFile = function downloadChangeLogVersionFile(data) {
  return {
    type: _analyticSession.actionTypes.DOWNLOAD_CHANGE_LOG_VERSION_FILE,
    payload: data
  };
};
exports.downloadChangeLogVersionFile = downloadChangeLogVersionFile;